import Vue from 'vue'

export default {
  /**
   * サインインユーザー情報を格納
   * @param {Object} state index内のstate参照
   * @param {String} user サインインユーザーID
   */
  setCurrentUser (state, user) {
    state.currentUser = user
    state.isSignIn = true
  },
  /**
   * サインインユーザーの所属テナントを格納
   * @param {Object} state index内のstate参照
   * @param {String} tenant サインインユーザーの所属テナント
   */
  setTenant (state, tenant) {
    state.tenant = tenant
  },
  /**
   * 読み込みフラグを格納
   * @param {Object} state index内のstate参照
   * @param {Boolean} isLoading 読み込み中ならtrue,そうでなければfalse
   */
  setIsLoading (state, isLoading) {
    state.isLoading = isLoading
  },
  /**
   * グループエラーフラグを格納
   * @param {Object} state index内のstate参照
   * @param {Boolean} error エラーフラグ
   */
  setIsGroupsError (state, error) {
    state.groups.error = error
  },
  /**
   * ユーザーエラーフラグを格納
   * @param {Object} state index内のstate参照
   * @param {Boolean} error エラーフラグ
   */
  setIsUsersError (state, error) {
    state.users.error = error
  },
  /**
   * 日報エラーフラグを格納
   * @param {Object} state index内のstate参照
   * @param {Boolean} error エラーフラグ
   */
  setIsDiariesError (state, error) {
    state.diaries.error = error
  },
  /**
   * グループ表示フラグを格納
   * @param {Object} state index内のstate参照
   */
  setToggleShowMenu (state) {
    localStorage.setItem('isShowMenu', !state.isShowMenu)
    state.isShowMenu = !state.isShowMenu
  },
  /**
   * 現在の日付を格納
   * @param {Object} state index内のstate参照
   * @param {Moment} date コンポーネントで受け渡したい日付
   */
  setThisDate (state, date) {
    state.thisDate = date
  },
  /**
   * グループを格納
   * @param {Object} state index内のstate参照
   * @param {Object} group actionsで取得したグループ
   */
  addGroups (state, groups) {
    let groupList = state.groups.data
    groupList.push(...groups)
    state.groups.data = groupList.sort((a, b) => {
      if (a.priority < b.priority) return -1
      if (a.priority > b.priority) return 1
      return 0
    })
  },
  /**
   * グループにユーザーがいないかどうかを格納
   * @param {Object} state index内のstate参照
   * @param {Boolean} isNoUsersInSelectedGroup グループにユーザーいないか
   */
  setIsNoUsersInSelectedGroup (state, isNoUsersInSelectedGroup) {
    state.isNoUsersInSelectedGroup = isNoUsersInSelectedGroup
  },
  /**
   * グループが存在するかのフラグを格納
   * @param {Object} state index内のstate参照
   * @param {Boolean} existsGroup グループが存在するか
   */
  setExistsGroup (state, existsGroup) {
    state.existsGroup = existsGroup
  },
  /**
   * リレーションが存在するかのフラグを格納
   * @param {Object} state index内のstate参照
   * @param {Boolean} existsRelation グループが存在するか
   */
  setExistsRelation (state, existsRelation) {
    state.existsRelation = existsRelation
  },
  /**
   * グループに子を設定する
   * @param {Object} state index内のstate参照
   * @param {Object} childrenUsers 子のユーザー情報
   */
  setChildrenUsers (state, childrenUsers) {
    state.groups.data.find(g => g.id === state.selectedGroupId).isLoaded = true
    state.groups.data.find(g => g.id === state.selectedGroupId).children.users = childrenUsers
  },
  /**
   * 選択したグループのIDを格納
   * 再アクセス時に最後に選択されていたグループを表示させるためにlocalStorageにも格納
   * @param {Object} state index内のstate参照
   * @param {Object} groupId 選択したグループのID
   */
  setSelectedGroupId (state, groupId) {
    localStorage.setItem('selectedGroupId', groupId)
    state.selectedGroupId = groupId
  },
  /**
   * 月表示、日表示に表示するユーザーの格納
   * @param {Object} state index内のstate参照
   * @param {Object} users 選択されたユーザー
   */
  setSelectedUsers (state, users) {
    users.sort((a, b) => {
      if (a.priority < b.priority) return -1
      if (a.priority > b.priority) return 1
      return 0
    })
    state.selectedUsers = users.filter(user => user.id === state.currentUser.id)
      .concat(users.filter(user => user.id !== state.currentUser.id))
  },
  /**
   * 現在のユーザーIDを格納
   * @param {Object} state index内のstate参照
   * @param {String} userId 現在のユーザーID
   */
  setSelectedUserId (state, userId) {
    localStorage.setItem('selectedUserId', userId)
    state.selectedUserId = userId
  },
  /**
   * ユーザーを追加
   * @param {Object} state index内のstate参照
   * @param {Object} users actionsで取得した全ユーザー
   */
  addUsers (state, users) {
    state.users.data.push(...users)
  },
  /**
   * 日報を格納
   * @param {Object} state index内のstate参照
   * @param {String} id 日報を投稿したユーザーのID
   * @param {Object} diaries ユーザーの投稿した日報データ
   */
  setDiaries (state, {id, diaries}) {
    Vue.set(state.diaries.data, id, diaries)
  },
  /**
   * 現在編集中かどうかを格納
   * @param {boolean} changed 現在編集中かどうか
   */
  setHasChanged (state, changed) {
    state.hasChanged = changed
  },
  /**
   * インポートの状態を格納
   * @param {Object} value DBから取得したインポートの状態 { run: 実行状態, user: 実行してるユーザー }
   */
  setImport (state, value) {
    state.import = value
  },
  /**
   * Teams投稿先メールアドレスを格納
   * @param {Object} state index内のstate参照
   * @param {String} mailAddress メールアドレス
   */
  setTeamsMailAddress (state, mailAddress) {
    state.teamsMailAddress = mailAddress
  },
  /**
   * 勤怠連絡先メールアドレスを格納
   * @param {Object} state index内のstate参照
   * @param {String} mailAddress メールアドレス
   */
  setWorkMailAddress (state, mailAddress) {
    state.workMailAddress = mailAddress
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js